
import React, { useState } from 'react';
import { Button } from '../base/Button';
import { href, Link } from 'react-router-dom';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isRegionalOpen, setIsRegionalOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [isExperienceOpen, setIsExperienceOpen] = useState(false);

  const navItems = [
    { label: 'Company', href: '#' },
    { label: 'about', href: '/about' },
    { label: 'Experience', href: '/experience' },
    { label: 'Group Tours', href: '/group-tours' },
    { label: 'careers', href: '/careers' },
    { label: 'Cruises', href: '/cruises' },
    { label: 'Adventure', href: '/adventure' },
    { label: 'Contact', href: '/contact' },
  ];

  const regionalItems = [
    {
      label: 'Asian Series',
      href: '/regional/asia',
      description: 'Discover the diverse cultures, ancient temples, bustling cities, and pristine beaches across Asia. From the Himalayas to tropical islands, experience the continent\'s rich heritage and modern marvels.'
    },
    {
      label: 'African Series',
      href: '/regional/africa',
      description: 'Embark on safari adventures, explore ancient civilizations, and witness breathtaking landscapes. From the Sahara Desert to Victoria Falls, Africa offers unparalleled wildlife and cultural experiences.'
    },
    {
      label: 'North America',
      href: '/regional/north-america',
      description: 'Experience diverse landscapes from Arctic tundra to tropical beaches. Explore vibrant cities, national parks, and cultural landmarks across the United States, Canada, and Mexico.'
    },
    {
      label: 'South America',
      href: '/regional/south-america',
      description: 'Journey through the Amazon rainforest, scale the Andes mountains, and discover ancient Incan ruins. Experience the passion of tango, carnival celebrations, and diverse ecosystems.'
    },
    {
      label: 'European Series',
      href: '/regional/europe',
      description: 'Immerse yourself in centuries of history, art, and culture. From medieval castles to modern cities, enjoy world-class cuisine, museums, and architectural wonders across the continent.'
    },
    {
      label: 'Oceania',
      href: '/regional/australia',
      description: 'Explore the unique wildlife, stunning coastlines, and vibrant cities of Australia and Oceania. From the Great Barrier Reef to the Outback, discover this continent\'s natural wonders.'
    },
    {
      label: 'Antarctica',
      href: '/regional/antarctica',
      description: 'Experience the ultimate adventure to the world\'s last frontier. Witness pristine wilderness, incredible wildlife, and breathtaking ice formations in this untouched continent.'
    }
  ];

  const moreItems = [
    { label: 'Career', href: '/career' },
    // { label: 'Blog', href: '/blog' },
    // { label: 'My Account', href: '/my-account' },
    // { label: 'FAQ', href: '/faq' }
  ];


  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/">
              <img
                src="/logo/logo.png"
                alt="PrimeMeridian Travel"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Company
            </Link>
            {/* <Link to="/group-tours" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Group Tours
            </Link>*/

            <div className="relative group">
              <button className="text-gray-700 hover:text-emerald-600 transition-colors flex items-center">
                Series
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-[1000px] bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 border border-gray-100">
                <div className="p-6">
                  <div className="grid grid-cols-4 gap-4">
                    {regionalItems.slice(0, 4).map((item, index) => (
                      <Link
                        key={index}
                        to={item.href}
                        className="group/item p-4 rounded-lg hover:bg-emerald-50 transition-colors"
                      >
                        <div className="flex flex-col space-y-3">
                          <div className="flex items-center space-x-2">
                            <div className="flex-shrink-0 w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center group-hover/item:bg-emerald-200 transition-colors">
                              <i className="ri-map-pin-line text-emerald-600 text-xs"></i>
                            </div>
                            <h3 className="font-semibold text-gray-900 group-hover/item:text-emerald-600 transition-colors text-sm">
                              {item.label}
                            </h3>
                          </div>
                          <p className="text-xs text-gray-600 leading-relaxed">
                            {item.description}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>
                  <div className="grid grid-cols-3 gap-4 mt-4">
                    {regionalItems.slice(4).map((item, index) => (
                      <Link
                        key={index + 4}
                        to={item.href}
                        className="group/item p-4 rounded-lg hover:bg-emerald-50 transition-colors"
                      >
                        <div className="flex flex-col space-y-3">
                          <div className="flex items-center space-x-2">
                            <div className="flex-shrink-0 w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center group-hover/item:bg-emerald-200 transition-colors">
                              <i className="ri-map-pin-line text-emerald-600 text-xs"></i>
                            </div>
                            <h3 className="font-semibold text-gray-900 group-hover/item:text-emerald-600 transition-colors text-sm">
                              {item.label}
                            </h3>
                          </div>
                          <p className="text-xs text-gray-600 leading-relaxed">
                            {item.description}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <div className="text-center">
                      <p className="text-sm text-gray-500 mb-2">Can't find your destination?</p>
                      <Link
                        to="/contact"
                        className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-medium text-sm"
                      >
                        Contact our travel experts
                        <i className="ri-arrow-right-line ml-1"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div> }

            <div className="relative group">
              <button className="text-gray-700 hover:text-emerald-600 transition-colors flex items-center">
                Experience
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-48 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 border border-gray-100">
                <div className="py-2">
                  <Link to="/cruises" className="block px-4 py-2 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 transition-colors">Cruises</Link>
                  <Link to="/adventure" className="block px-4 py-2 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 transition-colors">Adventure</Link>
                  <Link to="/book-villa-online" className="block px-4 py-2 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 transition-colors">Stays</Link>
                </div>
              </div>
            </div>
            {/* <Link to="/cruises" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Cruises
            </Link>
            <Link to="/adventure" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Adventure
            </Link>
            <Link to="/book-villa-online" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Stays
            </Link>*/
            <Link to="/contact" className="text-gray-700 hover:text-emerald-600 transition-colors">
              Contact
            </Link> }
            {/* <div className="relative group">
              <button className="text-gray-700 hover:text-emerald-600 transition-colors flex items-center">
                More
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 border border-gray-100">
                <div className="py-2">
                  {moreItems.map((item, index) => (
                    <Link
                      key={index}
                      to={item.href}
                      className="block px-4 py-2 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 transition-colors"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div> */}
          </nav>

          {//Login Button
          <div className="hidden lg:flex items-center">
            <Button variant="outline" size="sm">
              <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
              Log In
            </Button>
          </div> }

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-emerald-600 hover:bg-gray-100"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
            <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-emerald-600">
              Home
            </Link>
            <Link to="/about" className="block px-3 py-2 text-gray-700 hover:text-emerald-600">
              Company
            </Link>
            
            <div className="px-3 py-2">
              <button
                onClick={() => setIsRegionalOpen(!isRegionalOpen)}
                className="flex items-center justify-between w-full text-gray-700 hover:text-emerald-600"
              >
                Series
                <i className={`ri-arrow-${isRegionalOpen ? 'up' : 'down'}-s-line`}></i>
              </button>
              {isRegionalOpen && (
                <div className="mt-2 pl-4 space-y-2">
                  {regionalItems.map((item, index) => (
                    <Link
                      key={index}
                      to={item.href}
                      className="block py-2 text-gray-600 hover:text-emerald-600"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <div className="px-3 py-2">
              <button
                onClick={() => setIsExperienceOpen(!isExperienceOpen)}
                className="flex items-center justify-between w-full text-gray-700 hover:text-emerald-600"
              >
                Experience
                <i className={`ri-arrow-${isExperienceOpen ? 'up' : 'down'}-s-line`}></i>
              </button>
              {isExperienceOpen && (
                <div className="mt-2 pl-4 space-y-2">
                  <Link to="/cruises" className="block py-2 text-gray-600 hover:text-emerald-600">Cruises</Link>
                  <Link to="/adventure" className="block py-2 text-gray-600 hover:text-emerald-600">Adventure</Link>
                  <Link to="/book-villa-online" className="block py-2 text-gray-600 hover:text-emerald-600">Stays</Link>
                </div>
              )}
            </div>

            <Link to="/contact" className="block px-3 py-2 text-gray-700 hover:text-emerald-600">
              Contact
            </Link>
            {/* <div className="px-3 py-2">
              <button
                onClick={() => setIsMoreOpen(!isMoreOpen)}
                className="flex items-center justify-between w-full text-gray-700 hover:text-emerald-600"
              >
                More
                <i className={`ri-arrow-${isMoreOpen ? 'up' : 'down'}-s-line`}></i>
              </button>
              {isMoreOpen && (
                <div className="mt-2 pl-4 space-y-2">
                  {moreItems.map((item, index) => (
                    <Link
                      key={index}
                      to={item.href}
                      className="block py-2 text-gray-600 hover:text-emerald-600"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </header>
  );
};
